import { z } from 'zod';

/**
 * Standard-Query für Listen-Endpunkte (CLAUDE.md §8):
 *   ?page=1&pageSize=50&sort=-createdAt&q=<suche>
 * `coerce`, weil Query-Parameter immer als String ankommen.
 */
export const listQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(500).default(50),
  sort: z.string().optional(),
  q: z.string().optional(),
});

export type ListQuery = z.infer<typeof listQuerySchema>;

export const paginationMetaSchema = z.object({
  page: z.number().int(),
  pageSize: z.number().int(),
  total: z.number().int(),
});

export type PaginationMeta = z.infer<typeof paginationMetaSchema>;
